import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { MyWardrobePage } from './my-wardrobe.page';
import { SharedModule } from '../shared-module/shared.module';
import { MyWardrobePageRoutingModule } from './my-wardrobe-routing.module';

@NgModule({
  imports: [
    FormsModule,
    IonicModule,
    SharedModule,
    CommonModule,
    MyWardrobePageRoutingModule
  ],
  declarations: [MyWardrobePage]
})
export class MyWardrobePageModule {}
